import type { SettingDto } from 'api/src/core/schemas/SettingSchema';
import type PulseApi from '../../../api/PulseApi';
import Query from '../../../store/utils/query/Query';
import Setting from './Setting';

export default class SettingStore {
  constructor(private readonly api: PulseApi) {}

  createQuery(): Query<SettingDto, Setting[]> {
    return new Query({
      queryFunction: this.api.settings.getAllSettings.bind(this.api.settings),
      transformFunction: (response) =>
        response.items.map((item) => new Setting(item)),
    });
  }

  async update(model: Setting) {
    await this.api.settings.updateSetting(model);
  }
}
